export const GET_FORMS = 'GET_FORMS';
export const CURRENT_FORMS = 'CURRENT_FORMS';
export const CURRENT_TAB = 'CURRENT_TAB';
